/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{isValidMotionProp as t}from"../../../motion/utils/valid-prop.js";let o=o=>!t(o);function r(r){r&&(o=o=>o.startsWith("on")?!t(o):r(o))}try{r(require("@emotion/is-prop-valid").default)}catch(t){}function i(r,i,e){const n={};for(const a in r)"values"===a&&"object"==typeof r.values||(o(a)||!0===e&&t(a)||!i&&!t(a)||r.draggable&&a.startsWith("onDrag"))&&(n[a]=r[a]);return n}export{i as filterProps,r as loadExternalIsValidProp};
//# sourceMappingURL=filter-props.js.map
